import * as z from "zod";
import { gql } from "graphql-request";

import { FullscreenEntrySchema } from "./fullscreenEntry";
import { SysFragment } from "../sys";
import { FullscreenEntryCarouselFragment } from "./fullscreenCarousel";
import { RelatedMediaFragment } from "../relatedMedia";

export const EsportFullscreenEntrySchema = FullscreenEntrySchema.extend({
  __typename: z.literal("EsportFullscreenEntry"),
});

export const EsportFullscreenEntry = EsportFullscreenEntrySchema;
export type EsportFullscreenEntry = z.infer<typeof EsportFullscreenEntrySchema>;

export const EsportFullscreenEntryFragment = gql`
  fragment EsportFullscreenEntryFragment on EsportFullscreenEntry {
    __typename
    sys {
      ...SysFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    sortDate
    localized {
      ... on FullscreenEntryCarousel {
        ...FullscreenEntryCarouselFragment
      }
    }
  }

  ${SysFragment}
  ${FullscreenEntryCarouselFragment}
  ${RelatedMediaFragment}
`;
